import {computed, reactive} from 'vue';
const BaseStore = {
  state: reactive({
      items: [],
      originalItemsList: {},
      properties: {},
      listeners: {},
  }),
  isSaved: false,
  saveUrl: '',
  totalLength: function() {return computed(() => this.state.items.length);},
  addItem: function (item) {
    let maxId = this.getMaxId();
    item.id = maxId+1;
    this.state.items.push(item);
  },
  removeItem: function(id) {
     this.state.items = this.state.items.filter(item => item.id !== id);
  },
  setItems: function(items) {
      /*this.state.items = Object.assign({}, items);*/
     this.state.items = items;
  },
  getItems: function() {
     return this.state.items;
  },
  getMaxId: function () {
        return this.state.items.reduce((maxId, item)=>(maxId>item.id)?maxId:item.id, 0);
  },
  setCheckListObject: function(object) {
      this.state.items = [...object.items];
      this.state.originalItemsList = object;
  },
  isDirty: function() {
      return ((this.isSaved==false && this.state.items.length != this.state.originalItemsList.length)?true:false);
  },
  addProperty: function(name, value) {
      this.state.properties[name] = value;
  },
  setProperty: function(name, value) {
      this.addProperty(name, value);
  },
  getProperty: function(name) {
      return this.state.properties[name];
  },
  getProperties: function() {
      return this.state.properties;
  },
  addListener: function(name, callBack)
  {
      if (!this.state.listeners.hasOwnProperty(name)) {
          this.state.listeners[name] = [];
      }
      let m = {'callback': callBack};
      this.state.listeners[name].push(m);
  },
  removeListeners: function(name) {
      if (this.state.listeners.hasOwnProperty(name)) {
          delete this.state.listeners[name];
      }
  },
  emitEvent: function (name, evtParams) {
      if (!this.state.listeners.hasOwnProperty(name)) {
          return false;
      } else {
          this.state.listeners[name].forEach((elistener, index) => {
              //call the event
               try {
                   return elistener.callback(evtParams);
               } catch(e) {
                   /* handle error */
                   console.log('Error when try to call event '+name, e);
                   return null;
               }
          });
      }
  }

};
export default BaseStore;
